import { mapUserAnalysisQuotasData } from '@/shared/api/mappers/user-analysis-quotas';
import { useGetCurrentUserAnalysisQuotasQuery } from '@/shared/hooks/queries/generated';

export function useUserAnalysisQuotas() {
  const { data, isLoading, error } = useGetCurrentUserAnalysisQuotasQuery();

  const quotas = data?.getCurrentUserAnalysisQuotas
    ? mapUserAnalysisQuotasData(data.getCurrentUserAnalysisQuotas)
    : null;

  return {
    quotas,
    loading: isLoading,
    error: error || "Impossible de récupérer les quotas d'analyse",
  };
}
